import * as actionTypes from '../constants/actionTypes';
export function setInitialScreen(screenID) {
    return {
        type: actionTypes.SET_INITIAL_SCREEN,
        screenID: screenID,
    };
}
export function showNext(transition, meta) {
    return {
        type: actionTypes.SHOW_NEXT,
        transition: transition,
        meta: meta,
    };
}
export function showPrevious(transition, meta) {
    return {
        type: actionTypes.SHOW_PREVIOUS,
        transition: transition,
        meta: meta,
    };
}
export function showHome() {
    return { type: actionTypes.SHOW_HOME };
}
export function showScreen(screenID, transition, scrollPos, meta) {
    return {
        type: actionTypes.SHOW_SCREEN,
        screenID: screenID,
        transition: transition,
        scrollPos: scrollPos,
        meta: meta,
    };
}
export function screenResized(renderedScreenDimensions) {
    return {
        type: actionTypes.SCREEN_RESIZED,
        renderedScreenDimensions: renderedScreenDimensions,
    };
}
export function scrollTo(position, smoothScroll, meta) {
    return {
        type: actionTypes.SCROLL_TO,
        position: position,
        smoothScroll: smoothScroll,
        meta: meta,
    };
}
export function unsetScrollPos() {
    return {
        type: actionTypes.UNSET_SCROLL_POS,
    };
}
export function screenTimer(timer) {
    return {
        type: actionTypes.SCREEN_TIMER,
        timer: timer,
    };
}
export function imageLoaded(id) {
    return {
        type: actionTypes.IMAGE_LOADED,
        id: id,
    };
}
export function imageLoadFailed(id) {
    return {
        type: actionTypes.IMAGE_LOAD_FAILED,
        id: id,
    };
}
export function screenTransitionCompleted(_a) {
    var isCurrent = _a.isCurrent;
    return {
        type: actionTypes.SCREEN_TRANSITION_COMPLETED,
        isCurrent: isCurrent,
    };
}
export function showScreenInfo() {
    return {
        type: actionTypes.SHOW_SCREEN_INFO,
    };
}
export function hideScreenInfo() {
    return {
        type: actionTypes.HIDE_SCREEN_INFO,
    };
}
export function gifResetDone() {
    return {
        type: actionTypes.GIF_RESET_DONE,
    };
}
export function showHoverScreen(screenID, scrollPos, meta) {
    return {
        type: actionTypes.SHOW_HOVER_SCREEN,
        screenID: screenID,
        scrollPos: scrollPos,
        meta: meta,
    };
}
